<div [class]="!isMobile ?
     'container mt-5 ps-5 min-vh-79 mb-5 profile-settings-pc'
     : 'profile-settings-mb'">
  <ng-container *ngIf="isMobile; else pcHeaderPartTemplate">
    <div>
      <nav mat-tab-nav-bar [disablePagination]="true" [tabPanel]="tabPanel">
        <a mat-tab-link *ngFor="let item of getMenuItems"
           (click)="navigateToPage(item)"
           [active]="isRouteActive(item)">{{ item }}</a>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    </div>
  </ng-container>
  <ng-template #pcHeaderPartTemplate>
    <div class="row">
      <div class="card-header py-3">
        <h1 class="mb-0">Profile Settings</h1>
      </div>
    </div>
  </ng-template>

  <div [class]="!isMobile ? 'row h-100' : 'col-md-9 h-100 w-100 pt-3'">
    <ng-container *ngIf="!isMobile">
      <div class="card col-md-3 h-100 min-vh-79">
        <app-profile-menu></app-profile-menu>
      </div>
    </ng-container>

    <div class="col-md-9 h-100"
      [class]="isMobile ? 'w-100 pt-3' : 'min-vh-79'">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
